module.exports = __webpack_public_path__ + "img/cww_01.4475ada5.jpg";